import * as Yup from "yup"

const isValidUSPhone = (phoneNumber) => {
  if (!phoneNumber) return true
  const cleanedNumber = phoneNumber.replace(/\D/g, "")
  return phoneNumber.startsWith("+1") && cleanedNumber.length === 11
}

export default function validation_phone(field, acc) {
  const { field_name, field_validation } = field

  const checkBool = () => {
    if (!field_validation?.required) return false
    return field_validation.required[0] === "true"
  }

  const isRequired = checkBool()
  const isRequiredTxt =
    (field_validation?.required && field_validation.required[1]) ||
    "Required field."
  const invalidPhoneTxt =
    "Please enter a valid US phone number (maximum 11 digits)"

  let schema = Yup.string().test(
    "is-valid-us-phone",
    invalidPhoneTxt,
    (value) => isValidUSPhone(value),
  )

  if (isRequired) {
    schema = schema.required(isRequiredTxt)
  }

  return {
    [field_name]: schema,
    ...acc,
  }
}
